/**
 * WordPress dependencies
 */
import { __, _x } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/freeform",
  category: "formatting",
  attributes: {
    content: {
      type: "string",
      source: "html"
    }
  }
};
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: _x('Classic', 'block title'),
  description: __('Use the classic WordPress editor.'),
  icon: icon,
  supports: {
    className: false,
    customClassName: false,
    // Hide 'Add to Reusable Blocks' on Classic blocks. Showing it causes a
    // confusing UX, because of its similarity to the 'Convert to Blocks' button.
    reusable: false
  },
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map